import classNames from 'classnames';
import React from 'react';
import s from './playlistRowMoveTarget.module.scss';

interface Props {
  hide: boolean;
  posY?: number;
  width?: number;
}

export default function PlaylistMoveTarget({
  hide,
  posY,
  width,
}: Props) {

  return (
    <div
      style={{
        top: posY,
        width,
      }}
      className={classNames(s.moveTarget, {
        hide,
      })}
    >
    </div>
  );
}
